import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import { useEffect, useState } from "react";
import MaterialInput from "../../../components/MaterialInput";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { useInsurerKeyValueFormHandling } from './components/InsurerKeyValueStateHandle'
import MaterialButton from "../../../components/MaterialButton";
import { containerSX, overlaySX, progressBarSX, progressItemSX, stepBoxSX } from "./components/keyValueStyles";

const InsurerKeyValueForm = () => {
    const masterOptions = [
        { value: "1", label: "Motor" },
        { value: "2", label: "General" }
    ];
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    const location = useLocation();
    const categoryId = location?.state?.categoryId || "";
    const categoryName = location?.state?.categoryName || "";
    const insurerKVStoreId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit"
        ? "edit" : "add";

    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [insurerCategoryOptions, setInsurerCategoryOptions] = useState([]);
    const [parentKeyOptions, setParentKeyOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [storeOptions, setStoreOptions] = useState([]);

    const { keyValueData, setKeyValueData, handleKeyValueDataChange, checkAllFields } = useInsurerKeyValueFormHandling();

    useEffect(() => {

        setKeyValueData((prev) => ({
            ...prev,
            category: { label: categoryName, value: categoryId },
            categoryStatus: categoryId ? "success" : "undefined",
        }));
        const fetchInsurerCategoryData = async () => {
            try {
                const response = await fetchData(`/reference/insurer/key-value-category`);

                if (response?.success) {
                    setInsurerCategoryOptions(
                        response?.data?.items.map((item) => ({
                            value: item.id,
                            label: item.categoryName,
                        }))
                    );
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                showSnackbar("Error fetching data", "warning");
            }
        };
        fetchInsurerCategoryData();
    }, [categoryName]);

    useEffect(() => {
        //motor
        if (keyValueData?.master?.value === "1") {
            const fetchMotorCategoryData = async () => {
                setCircleLoading(true);
                try {
                    const response = await fetchData(`/reference/motor/key-value-category?dropdown=true`);

                    if (response?.success) {
                        const options = response?.data?.items.map((item) => ({
                            value: item.id,
                            label: item.categoryName,
                        }));
                        setCategoryOptions(options);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                    showSnackbar(error?.response?.data?.message, "error");
                } finally {
                    setCircleLoading(false);
                }
            };
            fetchMotorCategoryData();
        }
        //general
        else if (keyValueData?.master?.value === "2") {
            const fetchGeneralCategoryList = async () => {
                try {
                    setCircleLoading(true);
                    const response = await fetchData(`/reference/general/key-value-category`)
                    const responseData = response?.data?.items;

                    if (response?.success) {
                        const options = responseData.map((item) => ({
                            value: item.id,
                            label: item.categoryName,
                        }));
                        setCategoryOptions(options);
                    }
                    else {
                        //throw error
                        showSnackbar("Error Fetching Category Data", "error");
                    }
                } catch (error) {
                    console.error('Error Fetching Categories:', error);
                    showSnackbar(error?.response?.data?.message, "error");
                }
                finally{
                    setCircleLoading(false);
                }
            };
            fetchGeneralCategoryList();
        }
        else {
            return;
        }
    }, [keyValueData?.master])

    useEffect(() => {
        if (keyValueData?.baseKvCategory === "") {
            return;
        }
        //motor
        if (keyValueData?.master?.value === "1") {
            const fetchMotorKeyValue = async (categoryId) => {
                setCircleLoading(true);
                try {
                    const response = await fetchData(`/reference/motor/key-value-store?categoryId=${categoryId}&dropdown=true`);
                    if (response?.success) {
                        const options = response?.data?.items.map((item) => ({
                            value: item.id,
                            label: item.keyName,
                        }));
                        setStoreOptions(options);
                    }
                } catch (error) {
                    console.error("Error in fetching Key value Store");
                } finally {
                    setCircleLoading(false);
                }
            }
            fetchMotorKeyValue(keyValueData?.baseKvCategory?.value);
        }
        //general
        else if (keyValueData?.master?.value === "2") {
            const fetchGeneralKeyValueList = async (categoryId) => {
                setCircleLoading(true);
                try {
                    const response = await fetchData(`/reference/general/key-value-store?categoryId=${categoryId}&dropdown=true`)
                    if (response?.success) {
                        const options = response?.data?.items.map((item) => ({
                            value: item.id,
                            label: item.keyName,
                        }));
                        setStoreOptions(options);
                    }
                } catch (error) {
                    console.error('Error Fetching Key Values:', error);
                    showSnackbar(`Error Fetching Dropdown Data`, "warning");
                }
                finally {
                    setCircleLoading(false);
                }
            };
            fetchGeneralKeyValueList(keyValueData?.baseKvCategory?.value);
        }
        else {
            return;
        }
    }, [keyValueData?.baseKvCategory])

    useEffect(() => {
        const fetchData = async () => {

            if (insurerKVStoreId) {
            setCircleLoading(true);
            try {
                const response = await fetchDataById(`/reference/insurer/key_value_store/${insurerKVStoreId}`);

                const responseData = response?.data;
                
                if (response.success) {
                    const mapped = {
                        code: responseData?.code || "",
                        keyName: responseData?.keyName || "",
                        gInsurerId: {value: responseData?.gInsurerId, label: responseData?.gInsurerName},
                        // dropdowns (reverse of payload)
                        category: responseData?.category
                        ? { value: responseData.category.id, label: responseData.category.categoryName }
                        : null,
                        active: responseData?.isActive,

                        // status fields
                        codeStatus: responseData?.code ? "success" : "unchecked",
                        keyNameStatus: responseData?.keyName ? "success" : "unchecked",
                        gInsurerIdStatus: responseData?.gInsurerId ? "success" : "unchecked",
                        categoryStatus: responseData?.category?.id ? "success" : "unchecked",
                        workflowCategoryIdStatus: responseData?.workflowCategory ? "success" : "unchecked",
                    };

                    setKeyValueData(mapped);  
                }
            } catch (error) {
                console.error("Error Fetching:",error);
                showSnackbar(error?.response?.data?.message,"error");
            } finally {
                setCircleLoading(false);
            }
            }
        };

        fetchData();
    }, [insurerKVStoreId]);

    useEffect(() => {
        if (pageMode === "view") {
            return
        }
        fetchAllDropdowns();
    }, []);


    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
                insurerResponse,
                parentKeyResponse,

            ] = await Promise.all([
                fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`),
                fetchData(`/reference/insurer/key_value_store?categoryId=${categoryId || ""}`),
            ]);

            const formattedInsurers = insurerResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.companyName,
            })) || [];

            const formattedParentKeys = parentKeyResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            setGeneralInsurerOptions(formattedInsurers);
            setParentKeyOptions(formattedParentKeys);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error Fetching Dropdown", "warning");
        } finally {
            setCircleLoading(false);
        }
    };

    //handle submit api function    
    const handleAddKeyValue = async () => {

        const payload = {
            gInsurerId: keyValueData?.gInsurerId?.value,
            categoryId: categoryId,
            keyName: keyValueData?.keyName,
            code: keyValueData?.code,
            baseKvsId: keyValueData?.baseKvsId?.value,
            parentKeyId: keyValueData?.parentKeyId?.value ? keyValueData?.parentKeyId?.value : null,
            isActive: keyValueData?.active
        };
        //update
        if (insurerKVStoreId) {
            try {
                const response = await putData(`/reference/insurer/key_value_store/${insurerKVStoreId}`, payload);
                if (response.success) {
                    showSnackbar(response?.message, "success");
                    navigate("/insurer-master/insurer-key-value");
                }
            } catch (error) {
                console.error('Error updating data:', error);
            }
        }

        try {
            const response = await postData('/reference/insurer/key_value_store', payload);
            const successResponse = response?.success;
            const responseMessage = response?.message;
            if (successResponse) {
                showSnackbar(responseMessage, "success");
                navigate("/insurer-master/insurer-key-value");
            }
            else {
                showSnackbar(responseMessage, "error");
            }
        } catch (error) {
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message, "error");
        }
    };

    return (
        <DashboardLayout>
            <CardHeader
                title={
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <IconButton
                                onClick={() => navigate("/insurer-master/insurer-key-value")}
                            >
                                <ArrowBack />
                            </IconButton>
                            <Stack direction="column" spacing={0}>
                                <MaterialTypography variant="h5" fontWeight="medium">
                                    Insurer Key Value Details
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    Enter New Insurer Key Value Details.
                                </MaterialTypography>
                            </Stack>
                        </Stack>
                    </Stack>
                }
            />
            <CardContent sx={{ minHeight: "65vh" }}>
                <Grid2 container spacing={1}>

                    <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                            General Insurer
                        </MaterialTypography>
                        <MaterialSelect
                            name="gInsurerId"
                            value={keyValueData.gInsurerId}
                            onChange={handleKeyValueDataChange}
                            options={generalInsurerOptions}
                            success={keyValueData.gInsurerIdStatus === "success"}
                            error={keyValueData.gInsurerIdStatus === "error"}
                            isDisabled={pageMode === "view"}
                        />
                    </Grid2>

                    <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Category*
                        </MaterialTypography>
                        <MaterialSelect
                            name="category"
                            value={keyValueData.category}
                            customStyles={{ optionPadding: 20 }}
                            onChange={handleKeyValueDataChange} //selectedValue, event
                            options={insurerCategoryOptions?.map((value) => {
                                return {
                                    value: value.value,
                                    label: value.label,
                                };
                            })}
                            error={keyValueData.categoryStatus === "error" ? true : false}
                            success={keyValueData.categoryStatus === "success" ? true : false}
                            isDisabled={categoryId || pageMode === "view"}
                        />
                    </Grid2>

                    <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            {categoryName} Name*
                        </MaterialTypography>
                        <MaterialInput
                            name="keyName"
                            placeholder="eg. key name"
                            value={keyValueData.keyName}
                            onChange={handleKeyValueDataChange}
                            error={keyValueData.keyNameStatus === "error" ? true : false}
                            success={keyValueData.keyNameStatus === "success" ? true : false}
                            disabled={pageMode === "view"}
                        />
                        {keyValueData.keyNameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Name should be minimum of 1 character and maximum of 170 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>

                    <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            {categoryName} Code*
                        </MaterialTypography>
                        <MaterialInput
                            name="code"
                            placeholder="eg. CAT100"
                            value={keyValueData.code}
                            onChange={handleKeyValueDataChange}
                            error={keyValueData.codeStatus === "error" ? true : false}
                            success={keyValueData.codeStatus === "success" ? true : false}
                            disabled={pageMode === "view"}
                        />
                        {keyValueData.codeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Code should be minimum of 1 character and maximum of 25 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>

                    <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Parent Key ID
                        </MaterialTypography>
                        <MaterialSelect
                            name="parentKeyId"
                            value={keyValueData.parentKeyId}
                            options={parentKeyOptions}
                            onChange={handleKeyValueDataChange}
                            error={keyValueData.parentKeyIdStatus === "error" ? true : false}
                            success={keyValueData.parentKeyIdStatus === "success" ? true : false}
                            isDisabled={pageMode === "view"}
                        />
                    </Grid2>

                    <Grid2 size={{ lg: 2, md: 2, sm: 2, xs: 4 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Active
                        </MaterialTypography>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="active"
                                    checked={keyValueData.active}
                                    onChange={(event) =>
                                        handleKeyValueDataChange({
                                            target: {
                                                name: "active",
                                                value: event.target.checked,
                                            },
                                        })
                                    }
                                    disabled={pageMode === "view"}
                                    color="primary"
                                />
                            }
                            label={
                                <MaterialTypography variant="caption" fontWeight="bold">
                                    {keyValueData?.active ? "Yes" : "No"}
                                </MaterialTypography>
                            }
                            sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                    
                    <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <MaterialBox sx={containerSX}>
                            <MaterialTypography variant="subtitle2" fontWeight="bold" sx={{ mb: 2 }}>
                            Key Value Configuration
                            </MaterialTypography>

                            {/* Progress Bar */}
                        <MaterialBox sx={progressBarSX}>
                        {["Master", "Category", "Store"].map((_, index) => (
                            <MaterialBox
                            key={index}
                            sx={progressItemSX(
                                (index === 0 && keyValueData.master) ||
                                (index === 1 && keyValueData.baseKvCategory) ||
                                (index === 2 && keyValueData.baseKvsId)
                            )}
                            />
                        ))}
                        </MaterialBox>


                            <Grid2 container spacing={2}>

                            {/* STEP 1 */}
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox
                                sx={stepBoxSX(keyValueData.master ? "#75d846" : "#1976d2")}
                                >
                                <MaterialTypography variant="caption" fontWeight="bold">
                                     1. Master*
                                </MaterialTypography>

                                <MaterialSelect
                                    name="master"
                                    value={keyValueData.master}
                                    options={masterOptions}
                                    onChange={handleKeyValueDataChange}
                                    error={keyValueData.masterStatus === "error"}
                                    success={keyValueData.masterStatus === "success"}
                                    menuPlacement="top"
                                    isDisabled={pageMode === "view"}
                                />
                                </MaterialBox>
                            </Grid2>

                            {/* STEP 2 */}
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox
                                sx={stepBoxSX(
                                    keyValueData.baseKvCategory
                                    ? "#75d846"
                                    : keyValueData.master
                                    ? "#1976d2"
                                    : "#E0E0E0",
                                    keyValueData.master ? "#FFFFFF" : "#F5F5F5"
                                )}
                                >

                                <MaterialTypography variant="caption" fontWeight="bold">
                                    2. Key Value Category*
                                </MaterialTypography>

                                <MaterialSelect
                                    name="baseKvCategory"
                                    value={keyValueData.baseKvCategory}
                                    options={categoryOptions}
                                    onChange={handleKeyValueDataChange}
                                    error={keyValueData.baseKvCategoryStatus === "error"}
                                    success={keyValueData.baseKvCategoryStatus === "success"}
                                    isDisabled={!keyValueData.master || pageMode === "view"}
                                    menuPlacement="top"
                                />
                                </MaterialBox>
                            </Grid2>

                            {/* STEP 3 */}
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox
                                sx={stepBoxSX(
                                    keyValueData.baseKvsId
                                    ? "#75d846"
                                    : keyValueData.baseKvCategory
                                    ? "#1976d2"
                                    : "#E0E0E0",
                                    keyValueData.baseKvCategory ? "#FFFFFF" : "#F5F5F5"
                                )}
                                >

                                <MaterialTypography variant="caption" fontWeight="bold">
                                    3. Key Value Store*
                                </MaterialTypography>

                                <MaterialSelect
                                    name="baseKvsId"
                                    value={keyValueData.baseKvsId}
                                    options={storeOptions}
                                    onChange={handleKeyValueDataChange}
                                    error={keyValueData.baseKvsIdStatus === "error"}
                                    success={keyValueData.baseKvsIdStatus === "success"}
                                    isDisabled={!keyValueData.baseKvCategory || pageMode === "view"}
                                    menuPlacement="top"
                                />
                                </MaterialBox>
                            </Grid2>

                            </Grid2>
                        </MaterialBox>
                    </Grid2>

                </Grid2>
            </CardContent>
            <MaterialBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                {pageMode !== "view" && (
                    <>
                        <MaterialButton
                            sx={{ m: 2 }}
                            variant="outlined"
                            color="dark"
                            onClick={() => navigate("/insurer-master/insurer-key-value")}
                        >
                            Cancel
                        </MaterialButton>
                        <MaterialButton
                            sx={{ m: 2 }}
                            variant="gradient"
                            color="dark"
                            disabled={!checkAllFields()}
                            onClick={handleAddKeyValue}
                        >
                            {pageMode === "edit" ? "Update" : "Submit"}
                        </MaterialButton>
                    </>
                )}
            </MaterialBox>
        </DashboardLayout>
    )
}

export default InsurerKeyValueForm